import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { getNewYearContractReportsEndpoint } from '../../../common/endpoints';

export const newContractReporting = createApi(getNewYearContractReportsEndpoint, 'GET');

const ContractReporting = createSlice({
  name: 'ContractReporting',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(newContractReporting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newContractReporting.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(newContractReporting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ContractReporting.reducer;